import { BookingKitFilterState } from "./booking-kit-filter-state";
import { KitFilter } from "../hooks/use-booking-kit-search-filters";
import { isEmpty } from "lodash";
import { LegalPersonTypeWithNoOption } from "@bonliva-crm/shared";

export function mapFiltersToKitQueryInput(
  data: Partial<BookingKitFilterState>
): KitFilter {
  const result: KitFilter = {};
  if (!isEmpty(data.text)) {
    result.text = data.text;
  }

  if (!isEmpty(data.responsiblePerson)) {
    result.responsibleUserIds = data.responsiblePerson;
  }

  if (!isEmpty(data.projectResponsiblePersonId)) {
    result.projectResponsiblePersonIds = data.projectResponsiblePersonId;
    result.projectIds = [];
  }

  if (!isEmpty(data.areaOfExpertise)) {
    result.areasOfExpertises = data.areaOfExpertise;
  }

  if (!isEmpty(data.consultantIds)) {
    result.consultantIds = data.consultantIds.map((x) => x._id);
  }

  if (
    !isEmpty(data.hasLegalPersonType) &&
    data.hasLegalPersonType !== LegalPersonTypeWithNoOption.NoOption
  ) {
    result.legalPersonType = data.hasLegalPersonType as unknown as KitFilter["legalPersonType"];
  }

  if (!isEmpty(data.customerIds)) {
    result.customerIds = data.customerIds.map((x) => x.value);
  }

  if (!isEmpty(data.costCenter)) {
    result.costCenters = data.costCenter;
  }

  if (!isEmpty(data.managedBy)) {
    result.assignedUserIds = data.managedBy;
  }

  if (!isEmpty(data.groupInvoicing) && data.groupInvoicing !== "null") {
    if (data.groupInvoicing === "true") {
      result.isGroupInvoicing = true;
    }
    if (data.groupInvoicing === "false") {
      result.isGroupInvoicing = false;
    }
  }

  if (!isEmpty(data.isNational)) {
    result.isNationalProcurement = data.isNational === "true";
  }

  if (!isEmpty(data.kitStatusFilter)) {
    result.bookingKitStatuses = data.kitStatusFilter;
  }

  if (!isEmpty(data.consultantPayout)) {
    result.consultantPayoutType = data.consultantPayout;
  }

  if (!isEmpty(data.bookingKitTagFilter)) {
    result.bookingSupportTag = data.bookingKitTagFilter;
  }

  if (data.bookingDate?.from) {
    result.fromBookingDate = data.bookingDate.from || null;
  }

  if (data.bookingDate?.to) {
    result.toBookingDate = data.bookingDate.to || null;
  }

  if (!isEmpty(data.kitTypes)) {
    result.types = data.kitTypes;
  }

  return result;
}
